import { CampaignType, TimingOptionEnum } from '@dev/ee-api/ee-api-models';
import { Alert, Typography } from '@dev/ee-components';
import React, { PropsWithChildren } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { BillingPaths, pathsParams } from '@/services/dictionaries/Paths';
import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { Link } from '@material-ui/core';
import { ABReadyToSection } from '../ABReadyToSection/ABReadyTo';
import { AlertWrapper } from '../styled';
import { TimingOptionInfo } from '../TimingOptionInfo';
import { SendModalProps } from './SendModalInterface';

const RecipientsNumber = styled.div`
    display: flex;
    gap: 7px;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 24px;
`;

export const SendModal = ({ recipientsCount, children }: PropsWithChildren<SendModalProps>): JSX.Element => {
    const { t } = useTranslation();
    const { isPilotPlan, productCode } = useCurrentPlanStatus();
    const { campaign } = useSelector(getCampainCreatorStore);
    const isAbCampaign = campaign.Type === CampaignType.AbSplit;
    const timingOpt = campaign?.Options?.TimingOption || TimingOptionEnum.None;

    return isAbCampaign ? (
        <ABReadyToSection />
    ) : (
        <>
            <Typography variant="body1" bodyVariant="onPaper">
                {t('readytosend_desc')}
            </Typography>
            <RecipientsNumber>
                <Typography variant="h2">{recipientsCount}</Typography>
                <Typography variant="h4">{t('recipients_small')}</Typography>
            </RecipientsNumber>
            {isPilotPlan && (
                <AlertWrapper>
                    <Alert
                        severity="info"
                        body={
                            <Trans
                                i18nKey="pilotplan_send_campaing_alert"
                                components={{
                                    l: (
                                        <Link
                                            href={BillingPaths.BillingPlanList.replace(
                                                pathsParams.productCode,
                                                productCode?.toLowerCase?.()
                                            )}
                                        />
                                    ),
                                }}
                            />
                        }
                    />
                </AlertWrapper>
            )}
            {timingOpt !== TimingOptionEnum.None && <TimingOptionInfo />}
            {children}
        </>
    );
};
